import * as React from 'react';
import { Button, Tooltip } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import StepperInput from './StepperInput';
import { AppContext } from '../../../App';
import { MarkDispatchContext } from '../../../context/MarkContext';
import { useNavigate, useParams } from 'react-router';

export interface DocStepperProps {
  steps: number;
  docIndex: number;
  review: boolean;
  prefetchPage: () => void;
}
const DocStepper: React.FC<DocStepperProps> = ({ steps, docIndex, review, prefetchPage }) => {
  const dispatch = React.useContext<React.Dispatch<any>>(MarkDispatchContext);
  const { ids, dataPoolId } = React.useContext(AppContext);
  const navigate = useNavigate();
  const { id, tid } = useParams<{ id: string; tid: string }>();
  const handlePrev = () => {
    dispatch({ type: 'RESET_PAGE', payload: { resetFieldAndPage: true } });
    if (review) {
      if (tid) {
        navigate(
          `/data-pools/${dataPoolId}/extraction-batch-details/${id}/group/${tid}/review/${ids[docIndex - 1]}`
        );
      } else {
        navigate(`/data-pools/${dataPoolId}/extraction-batch/${id}/review/${ids[docIndex - 1]}`);
      }
    } else {
      navigate(`/data-pools/${dataPoolId}/train/${id}/mark/${ids[docIndex - 1]}`);
    }
  };
  const handleNext = async () => {
    await prefetchPage();
    dispatch({ type: 'RESET_PAGE', payload: { resetFieldAndPage: true } });
    /*
    review
      ? navigate(
          `/data-pools/${dataPoolId}/review/${id}/extraction/${
            ids[docIndex + 1]
          }`
        )
      : navigate(
          `/data-pools/${dataPoolId}/train/${id}/mark/${ids[docIndex + 1]}`
        );
        */
    if (review) {
      if (tid) {
        navigate(
          `/data-pools/${dataPoolId}/extraction-batch-details/${id}/group/${tid}/review/${ids[docIndex + 1]}`
        );
      } else {
        navigate(`/data-pools/${dataPoolId}/extraction-batch/${id}/review/${ids[docIndex + 1]}`);
      }
    } else {
      navigate(`/data-pools/${dataPoolId}/train/${id}/mark/${ids[docIndex + 1]}`);
    }
  };
  return (
    <div>
      <Tooltip title="Previous" placement="top">
        <span>
          <Button
            id="prev"
            onClick={handlePrev}
            disabled={docIndex === 0}
            data-cy="btn-previous-document"
            size="small"
            sx={{ padding: '6px 8px', minWidth: 'auto', fontSize: '0.75rem', lineHeight: 1.2 }}
          >
            <KeyboardArrowLeft sx={{ fontSize: 16 }} />
          </Button>
        </span>
      </Tooltip>
      <StepperInput
        key={`stepper-input-${docIndex}`}
        steps={steps}
        docIndex={docIndex}
        review={review}
      />
      <Tooltip title="Next" placement="top">
        <span>
          <Button
            id="next"
            disabled={docIndex === steps - 1}
            onClick={handleNext}
            data-cy="btn-next-document"
            size="small"
            sx={{ padding: '6px 8px', minWidth: 'auto', fontSize: '0.75rem', lineHeight: 1.2 }}
          >
            <KeyboardArrowRight sx={{ fontSize: 16 }} />
          </Button>
        </span>
      </Tooltip>
    </div>
  );
};

export default DocStepper;
